<div class="form-group">
  <div class="input-group date" chDatepicker [datetime]="datetime" [monthOnly]="monthOnly" [date]="date" [minDate]="getMinDateIfPresent()"
    (onChange)="change($event)">
    <div *ngIf="value" class="input-group-btn">
      <button type="button" class="btn btn-default" (click)="clear()">
        <span class="glyphicon glyphicon-remove"></span>
      </button>
    </div>
    <input type="text" class="form-control" value="{{ value }}" onkeydown="return false" />
    <span class="input-group-addon">
      <span class="fa fa-calendar"></span>
    </span>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/datepicker/datepicker.component.html